import { Plus } from 'lucide-react';
import { useState } from 'react';
import { CIRCLES } from '../../constants/circles.constants';
import { useCircles } from '../../hooks/useCircles';
import CircleCard from './CircleCard';
import CreateCircleModal from './CreateCircleModal';
import './circles.scss';

const CirclesComponent = () => {
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const { circles, loading, error } = useCircles();

  return (
    <div className="circles">
      <div className="circles__header">
        <h2 className="circles__title">{CIRCLES.TITLE}</h2>
        <button
          type="button"
          className="circles__add-btn"
          onClick={() => setIsCreateOpen(true)}
          aria-label={CIRCLES.ARIA.CREATE}
        >
          <Plus size={20} />
        </button>
      </div>

      {loading && circles.length === 0 && (
        <p className="circles__empty">{CIRCLES.LOADING}</p>
      )}

      {error && <p className="circles__error">{error.message}</p>}

      {!loading && !error && circles.length === 0 && (
        <p className="circles__empty">{CIRCLES.EMPTY_STATE}</p>
      )}

      <div className="circles__grid">
        {circles.map((circle) => (
          <CircleCard key={circle.id} circle={circle} />
        ))}
      </div>

      <CreateCircleModal
        open={isCreateOpen}
        onClose={() => setIsCreateOpen(false)}
      />
    </div>
  );
};

export default CirclesComponent;
